import { render, staticRenderFns } from "./xxtr1.vue?vue&type=template&id=3ff37d6d&scoped=true&"
import script from "./xxtr1.vue?vue&type=script&lang=js&"
export * from "./xxtr1.vue?vue&type=script&lang=js&"
import style0 from "./xxtr1.vue?vue&type=style&index=0&id=3ff37d6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff37d6d",
  null
  
)

export default component.exports